import React, { useEffect, useState } from 'react'
import Graytextarea from '../../components/Graytextarea'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

const ReviewOfSystem = ({ noteStructureRef, showTreatmentAsAccordion = false }) => {
  const [value, setValue] = useState('')
  const [draftValue, setDraftValue] = useState('')
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const reviewValue = noteStructureRef?.current?.reviewOfSystem?.editROS || ''
    setValue(reviewValue)
    setDraftValue(reviewValue)
  }, [noteStructureRef])

  const openModal = () => {
    const reviewValue = noteStructureRef?.current?.reviewOfSystem?.editROS || value || ''
    setDraftValue(reviewValue)
    setVisible(true)
  }

  const handleSave = () => {
    const nextValue = draftValue || ''
    setValue(nextValue)

    const noteStructure = noteStructureRef?.current
    if (noteStructure) {
      if (typeof noteStructure.reviewOfSystem !== 'object' || noteStructure.reviewOfSystem === null) {
        noteStructure.reviewOfSystem = {}
      }

      noteStructure.reviewOfSystem.editROS = nextValue
      noteStructure.reviewOfSystem.freeType = nextValue
    }

    setVisible(false)
  }

  return (
    <>
      <div>
        <h6 className={`${showTreatmentAsAccordion ? 'fs-7' : 'text-primary'}`} style={{ color: '#808080', opacity: '0.8' }}>
          Review of system
        </h6>
        <hr />

        <Graytextarea
          className="border rounded shadow-sm mt-2"
          rows={1}
          height="44px"
          value={value}
          readOnly
          onClick={openModal}
          onFocus={openModal}
          style={{ cursor: 'pointer' }}
          placeholder="Enter Review of system"
        />
      </div>

      <CModal backdrop="static" alignment="start" className="review-of-system-modal" visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Review of system</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Graytextarea
            height="140px"
            value={draftValue}
            onChange={(e) => setDraftValue(e.target.value)}
            placeholder="Enter Review of system"
          />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" onClick={handleSave}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ReviewOfSystem
